import { render, staticRenderFns } from "./TileBasic.vue?vue&type=template&id=212ecb47&scoped=true&"
import script from "./TileBasic.vue?vue&type=script&lang=js&"
export * from "./TileBasic.vue?vue&type=script&lang=js&"
import style0 from "./TileBasic.vue?vue&type=style&index=0&id=212ecb47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ecb47",
  null
  
)

export default component.exports